import React, { Component } from 'react';
import { withAuth } from "../../app/util/HOC";
import StudyCenterStudentPage from './StudyCenterStudentPage';
import StudyCenterProfessorPage from './StudyCenterProfessorPage';
export function StudyBoardProfStud(props) {
    let isLoggedInRole = props.userRole;
    if (isLoggedInRole === "Professor") {
        return <StudyCenterProfessorPage />;
    }
    return <StudyCenterStudentPage />;
}
export class StudyCenterLandingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userVO: JSON.parse(localStorage.getItem('userVO')),
        }
    }
    render() {
        const { userVO } = this.state;
        return (
            <div>
                {
                    userVO !== undefined ?
                        <StudyBoardProfStud userRole={userVO.userRole} /> : null
                }
            </div>
        )
    }
}
export default withAuth(StudyCenterLandingPage);